import React, { FC } from 'react';
import { BodyText, PaywallButton } from '@minecraft.atoms';
import { Trans, useTranslation } from '@blocs.i18n';
import { HEADSHOTS_MODAL_ACTION_PROPS, HeadshotsModalLayout } from './HeadshotsModalLayout';

export type HeadshotsAnnualModalProps = {
  /** Next booking date, formatted as "March 10, 2027". Empty when the BE has no reset date. */
  nextSessionDate: string;
  onUploadMedia: () => void;
  onClose: () => void;
};

/**
 * Modal for an annual subscriber who has used both yearly headshot sessions.
 * Copy only — eligibility, formatting, and navigation live in `useHeadshotAnnualModal`.
 */
export const HeadshotsAnnualModal: FC<HeadshotsAnnualModalProps> = ({ nextSessionDate, onUploadMedia, onClose }) => {
  const { t } = useTranslation();

  return (
    <HeadshotsModalLayout
      title={t('talent:headshots.annualModal.title')}
      summary={
        <BodyText>
          {t('talent:headshots.annualModal.body')}
          {nextSessionDate && (
            <>
              {' '}
              <Trans
                i18nKey="talent:headshots.annualModal.nextSession"
                values={{ nextSessionDate }}
                components={{ bold: <BodyText as="span" fontWeight="bold" /> }}
              />
            </>
          )}
        </BodyText>
      }
      details={<BodyText fontWeight="semibold">{t('talent:headshots.annualModal.prompt')}</BodyText>}
      actions={
        <PaywallButton
          color="gold"
          {...HEADSHOTS_MODAL_ACTION_PROPS}
          label={t('talent:headshots.annualModal.uploadMedia')}
          onClick={onUploadMedia}
        />
      }
      closeLabel={t('common:button.close')}
      onClose={onClose}
    />
  );
};

export default HeadshotsAnnualModal;
